import React from "react";
import { FaIndustry } from "react-icons/fa";
import "./About.css";
import ContactPopup from "../components/ContactPopup";



import factoryFrontImg from '../assets/factory-front.png';
import factoryCuttingImg from '../assets/factory-cutting.png';
import factoryFabricStore from "../assets/factory-fabric-store.png";
import factoryEcoPackagingImg from '../assets/factory-packaging.png';
import factoryFRC from "../assets/frc-singapore.png";
import factoryExpansion from "../assets/factory-2026.png";
import factory2022 from "../assets/factory-2022.png";

import processFabricImg from "../assets/process-fabric.png";
import processSewing from "../assets/process-sewing.png";
import processQuality from "../assets/process-quality.png";

import saiSenaImpexImg from '../assets/logo-saisena.jpeg';
import saiTextileImg from '../assets/logo-saitextiles.png';
import Hero from "../components/Hero";


import pdtGraphicTees from "../assets/pdt-graphic-tee1.png";
import pdtJogger from "../assets/pdt-joggers1.png";
import pdtKidsSet1 from "../assets/pdt-kids-set1.png";
import pdtKidsSet2 from "../assets/pdt-kids-set2.png";
import pdtRomper from "../assets/pdt-romper.png";
import pdtRomper2 from "../assets/pdt-romper2.png";
import pdtRomper3 from "../assets/pdt-romper3.png";
import pdtRomper4 from "../assets/pdt-romper4.png";
import pdtSweatshirt from "../assets/pdt-sweatshirts1.png";
import pdtWomens1 from "../assets/pdt-womens1.png";
import pdtWomens2 from "../assets/pdt-womens2.png";
import pdtBodySuit from "../assets/pdt-bodysuit1.png";
import pdtBodySuit2 from "../assets/pdt-bodysuit2.png";
import pdtBodySuit3 from "../assets/pdt-bodysuit3.png";

//Woven garment products
import pdtArcSuit from "../assets/pdt-arcsuit.png";
import pdtFrcSuit from "../assets/pdt-frc-suit.png";
import pdtFrcCoverall from "../assets/pdt-frc-coverall.png";
import pdtMedicalScrubs from "../assets/pdt-medical-scrubs2.png";
import pdtUnifromPolos from "../assets/pdt-uniform-polos.png";
import shirtImg from "../assets/pdt-shirt.png";
import boxerImg from "../assets/pdt-boxer-shorts.jpg";

//Home textile products
import apronImg from "../assets/pdt-apron.jpg";
import tableCothImg from "../assets/pdt-table-cloth.png";
import laundryBagImg from "../assets/pdt-laundry-bag.jpg";
import totebagImg from "../assets/pdt-totebag.jpg";
import fcushionImg from "../assets/pdt-floor-cushion.jpg";
import bathTowelsImg from "../assets/pdt-bath-towels.png";


export default function About() {
  const [popupOpen, setPopupOpen] = React.useState(false);

  return (
    <main className="about-container">
      {/* HERO / INTRO */}
      <Hero
  size="small"
  eyebrow="About Sai Sena"
  headline="Empowering Through Excellence"
  body="Learn more about our mission, values, and commitment to quality and sustainability."
  bgImage={require("../assets/hero-about3.jpg")}
/>

      {/* OUR ORGANIZATION */}
      <section className="section-about-grey">
        <div className="about-section-inner">
          <h2>How We Are Built</h2>
          <div className="org-split">
            {/* Left: Sai Sena Impex */}
            <div className="org-card">
              <img src={saiSenaImpexImg} alt="Sai Sena Impex" style={{ width: 160, height: 160, objectFit: "contain" }}/>
              <p>
                Specialists in <b>casual wear, sportswear, and kidswear</b>.  
                Founded in 2020, focused on global apparel manufacturing with 
                agility, precision, and sustainable practices.
              </p>
            </div>

            {/* Right: Sai Textiles */}
            <div className="org-card">
              <img src={saiTextileImg} alt="Sai Textiles" style={{ width: 160, height: 160, objectFit: "contain" }} />
              <p>
                Global specialists in <b>certified workwear, protective FR clothing, and medical scrubs </b> meeting international standards.
Experts in <b>premium woven garments and home textiles</b>, from professional apparel to domestic linen solutions.
              </p>
            </div>
          </div>
        </div>
        <br/>
      </section>
      {/* MISSION & VISION */}
      <section className="section-about-white">
        <div className="about-section-inner" style={{textAlign:'center',maxWidth:"800px", marginBottom: '2rem'}}>
          <h2>Our Mission & Vision</h2>
          <p>
            <b>Mission:</b> To become a global garment manufacturing leader by driving innovation, 
            ensuring quality, building customer satisfaction, empowering our workforce, and 
            delivering on time with cost efficiency.
          </p>
          <p style={{marginTop:'1rem'}}>
            <b>Vision:</b> To be present in every wardrobe worldwide, recognized for our commitment 
            to sustainability, excellence, and innovation in garment manufacturing.
          </p>
        </div>
        <div className="gradient-divider"/>
      </section>
      {/* OUR PROMISE / USP CARDS */}
      <section class="usp-sec">
  <h2 class="grad-title"><span class="emoji">🏅</span> What Sets Us Apart</h2>

  <div class="usp-grid">
    <article class="usp-card">
      <div class="usp-icon usp-purple">🤝</div>
      <h3>End‑to‑End Service</h3>
      <p>From yarn sourcing to packed, finished garments—total control, total care.</p>
    </article>

    <article class="usp-card">
      <div class="usp-icon usp-orange">🛡️</div>
      <h3>Certified Safety</h3>
      <p>Workwear passes global standards (NFPA, EN ISO, ASTM, ATPV).</p>
    </article>

    <article class="usp-card">
      <div class="usp-icon usp-purple">👥</div>
      <h3>Customer Focus</h3>
      <p>Fast samples, flexible orders, and dedicated partnerships.</p>
    </article>

    <article class="usp-card">
      <div class="usp-icon usp-gold">🏅</div>
      <h3>Global Quality</h3>
      <p>Premium materials, expert stitching, AQL‑checked results—every order.</p>
    </article>
    <article class="usp-card">
      <div class="usp-icon usp-green">🌱</div>
      <h3>Sustainability</h3>
      <p>Ethical practices, responsible sourcing, and eco‑minded packaging across the value chain.</p>
    </article>
    <article class="usp-card">
      <div class="usp-icon usp-cyan">⚡</div>
      <h3>Rapid Development</h3>
      <p>Agile sampling, CAD‑driven fits, and swift pilot runs to reduce time‑to‑market.</p>
    </article>
  </div>
</section>
      

      {/* OUR JOURNEY */}
      <section className="section-about-grey">
        <div className="about-section-inner" style={{textAlign:'center'}}>
          <h2>Our Journey</h2>
          <JourneyTimelineVertical />
        </div>
        <div className="gradient-divider"/>
      </section>

      {/* HOW WE WORK */}
      <section className="proc-sec">
        <h2 className="grad-title">
            <span className="emoji">🚀</span> Our Process &amp; Factory
          </h2>
      <div className="proc-flex">
        
        <div className="proc-list-shell">
          <ol className="proc-list">
            <li>
              <span className="proc-num">1</span>
              <div className="proc-body">
                <h3>Certified Input</h3>
                <p>Only the best yarns, fabrics & trims.</p>
              </div>
            </li>
            <li>
              <span className="proc-num">2</span>
              <div className="proc-body">
                <h3>Skilled Cutting &amp; Sewing</h3>
                <p>Expert tailoring with attention to detail.</p>
              </div>
            </li>
            <li>
              <span className="proc-num">3</span>
              <div className="proc-body">
                <h3>Quality Control</h3>
                <p>Step-by-step checks to ensure perfection.</p>
              </div>
            </li>
            <li>
              <span className="proc-num">4</span>
              <div className="proc-body">
                <h3>Packing &amp; Delivery</h3>
                <p>Eco packaging, global on‑time shipping.</p>
              </div>
            </li>
          </ol>
        </div>
        <div className="proc-slider-shell">
          <ProcAutoSlider />
        </div>
      </div>
    </section>

    {/* PRODUCT GLANCE SLIDER */}
      <section className="section-about-grey">
        <div className="about-section-inner" style={{maxWidth:"100%", padding:"0"}}>
          <h2>Product Glance</h2>
          <ProductGlance />
        </div>
      </section>
      {/* BROCHURE PREVIEW SECTION 
      <section className="brochure-section">
        <h2>View Our Brochure</h2>
        <PDFViewer url="../assets/brochure.pdf" />
      </section>
*/}

      {/* GLOBAL PRESENCE MAP */}
      <section className="section-about-white" style={{ textAlign: "center", padding: "2rem 0" }}>
        <h2>Global Presence</h2>
        <p style={{ maxWidth: 700, margin: "0 auto 2rem auto" }}>
          We proudly serve clients across the globe, delivering high-quality garments and technical textiles to leading brands in North America, Europe, Asia, Australia, the Middle East and beyond. Our commitment to excellence and reliability has enabled us to build lasting partnerships worldwide.
        </p>
        <img
          src={require("../assets/export-map.png")}
          alt="Sai Sena Impex Global Presence Map"
          style={{ width: "100%", height: "auto", borderRadius: "1.2rem" }}
        />
      </section>

      {/* Contact CTA */}
      <section className="contact-cta-section">
        <h2>Ready to Partner With Us?</h2>
        <p>
          Connect with us today for partnership opportunities and production requirements.<br />
          Let's create something extraordinary together.
        </p>
        <button className="btn-contact" onClick={() => setPopupOpen(true)}>
          Get In Touch
        </button>
      </section>
      <ContactPopup open={popupOpen} onClose={() => setPopupOpen(false)} />
    </main>
  );
}

// Add/replace at end of file:
function ProcAutoSlider() {
  const slides = [
    { img: processFabricImg, caption: "Premium fabric sourcing" },
    { img: processSewing , caption: "Expert sewing teams" },
    { img: processQuality, caption: "Dedicated quality control" },
    { img: factoryEcoPackagingImg, caption: "Eco packaging station" },
  ];

  const [idx, setIdx] = React.useState(0);
  const [paused, setPaused] = React.useState(false);
  const wrap = (i) => (i + slides.length) % slides.length;

  // Auto-advance with hover pause
  React.useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setIdx(i => wrap(i + 1)), 3200);
    return () => clearInterval(t);
  }, [paused, slides.length]);

  // Keyboard support
  React.useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowRight") setIdx(i => wrap(i + 1));
      if (e.key === "ArrowLeft") setIdx(i => wrap(i - 1));
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Pointer (mouse/touch) swipe/drag
  const startRef = React.useRef(null);
  const onPointerDown = (e) => {
    const x = "touches" in e ? e.touches[0].clientX : e.clientX;
    startRef.current = { x };
  };
  const onPointerMove = (e) => {
    // optional: visual drag could be added here
  };
  const onPointerUp = (e) => {
    if (!startRef.current) return;
    const startX = startRef.current.x;
    const endX = "changedTouches" in e ? e.changedTouches[0].clientX : e.clientX;
    const dx = endX - startX;
    const threshold = 40; // px
    if (dx > threshold) setIdx(i => wrap(i - 1));
    else if (dx < -threshold) setIdx(i => wrap(i + 1));
    startRef.current = null;
  };

  return (
    <div className="proc-slider"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}>
      <div
        className="proc-slider-img-shell"
        onMouseDown={onPointerDown}
        onMouseMove={onPointerMove}
        onMouseUp={onPointerUp}
        onTouchStart={onPointerDown}
        onTouchMove={onPointerMove}
        onTouchEnd={onPointerUp}
      >
        <img
          src={slides[idx].img}
          alt={slides[idx].caption}
          className="proc-slider-img"
          draggable="false"
        />
        <button
          className="proc-arrow left"
          aria-label="Previous slide"
          onClick={() => setIdx(i => (i - 1 + slides.length) % slides.length)}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 19L8 12l7-7" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <button
          className="proc-arrow right"
          aria-label="Next slide"
          onClick={() => setIdx(i => (i + 1) % slides.length)}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
      <div className="proc-slider-caption">{slides[idx].caption}</div>
    </div>
  );
}

function ProductGlance() {
  const products = [
    { img: pdtKidsSet1 },
    { img: pdtKidsSet2 },
    { img: pdtBodySuit },
    //{ img: pdtBodySuit2 },
    { img: pdtBodySuit3 },
    { img: pdtRomper },
    { img: pdtRomper2 },
    { img: pdtRomper3 },
    { img: pdtRomper4 },
    { img: pdtSweatshirt },
    { img: pdtGraphicTees },
    { img: pdtWomens1 },
    { img: pdtWomens2 },
    { img: pdtUnifromPolos },
    { img: pdtMedicalScrubs },
    { img: pdtArcSuit },
    { img: pdtFrcSuit },
    { img: pdtFrcCoverall },
    { img: shirtImg },
    { img: boxerImg },
    { img: apronImg },
    { img: tableCothImg },
    { img: laundryBagImg },
    { img: totebagImg },
    { img: fcushionImg },
    { img: bathTowelsImg }, 
    { img: pdtJogger },
    { img: pdtRomper },
  ];

  const visible = 5;
  const [start, setStart] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);
  const wrap = (i) => (i + products.length) % products.length;

  // Animate slide
  const slide = (dir) => {
    setAnimating(true);
    setTimeout(() => {
      setStart(i => wrap(i + dir));
      setAnimating(false);
    }, 400); // match CSS transition duration
  };

  // Auto-advance
  React.useEffect(() => {
    const timer = setInterval(() => slide(1), 2500);
    return () => clearInterval(timer);
  }, [products.length]);

  const visibleProducts = Array.from({ length: visible + 1 }, (_, idx) =>
    products[wrap(start + idx)]
  );

  return (
    <div className="glance-slider">
      <button className="glance-arrow left" onClick={() => slide(-1)} disabled={animating} aria-label="Previous slide">
        <svg viewBox="0 0 24 24" aria-hidden="true" width="32" height="32">
          <path d="M15 19L8 12l7-7" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
      <div className="glance-track-shell">
        <div
          className={`glance-track${animating ? " animating" : ""}`}
          style={{
            transform: animating ? "translateX(-20%)" : "translateX(0)",
            transition: animating ? "transform 0.4s cubic-bezier(0.5,0,0.5,1)" : "none"
          }}
        >
          {visibleProducts.map((p, i) => (
            <div className="glance-card" key={i}>
              <img src={p.img} alt={`Product ${wrap(start + i) + 1}`} className="glance-img" />
            </div>
          ))}
        </div>
      </div>
      <button className="glance-arrow right" onClick={() => slide(1)} disabled={animating} aria-label="Next slide">
        <svg viewBox="0 0 24 24" aria-hidden="true" width="32" height="32">
          <path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
}

// Usage in About page:
// <TimelineVertical />

function JourneyTimelineVertical() {
  const steps = [
    {
      year: "2020",
      title: "Sai Sena Impex was founded, marking the inception of the fabric trading",
      img:  factoryFabricStore
    },
    {
      year: "2022",
      title: "Sai Sena Impex into the Garment – Knits Division, broadening its manufacturing capabilities with its first ever factory",
      img: factory2022,
    },
    {
      year: "2023",
      title: "Sai Textiles founded it market into workwear solutions in Singapore and Malaysia",
      img: factoryFRC,
    },
    {
      year: "2024",
      title: "Sai Sena Impex Has expanded its production to 220+ machines and started its own garment export division",
      img: factoryFrontImg,
    },
    {
      year: "2026",
      title: "Sai Sena Impex is planning its further expansion and modernization of facilities",
      img: factoryExpansion,
    },
  ];

  const [idx, setIdx] = React.useState(0);
  const wrap = (i) => (i + steps.length) % steps.length;

  // Auto-slide every 3 seconds
  React.useEffect(() => {
    const timer = setInterval(() => setIdx(i => wrap(i + 1)), 5000);
    return () => clearInterval(timer);
  }, [steps.length]);

  return (
    <div className="journey-timeline-vertical">
      <div className="journey-timeline-vertical-bar">
        {steps.map((step, i) => (
          <div
            key={i}
            className={`journey-timeline-vertical-node${i === idx ? " active" : ""}`}
            onClick={() => setIdx(i)}
          >
            <div className="journey-timeline-vertical-dot">
              <FaIndustry className="journey-timeline-vertical-factory-icon" />
            </div>
            <div className={`journey-timeline-vertical-year${i === idx ? " active" : ""}`}>
              {step.year}
            </div>
          </div>
        ))}
      </div>
      <div className="journey-timeline-vertical-content">
        <div className="journey-timeline-vertical-desc">
          <div className="journey-timeline-vertical-title">{steps[idx].title}</div>
        </div>
        <div className="journey-timeline-vertical-img-shell">
          <img
            src={steps[idx].img}
            alt={steps[idx].year}
            className="journey-timeline-vertical-img"
          />
        </div>
      </div>
    </div>
  );
}